import React, { useState } from "react";
import { Checkbox, Divider, Form, Icon, Input } from "antd";
import DadataSearchBank from "../../../../Customers/modules/dadataBank/container";
import { isNumeric } from "../../../../../common/utils/validation";

export const BankForm = ({ form, disabled }) => {
  const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
  function handleChange(val, index) {
    val && val.data && updateBanks(val, index);
  }
  const [banksCount, setBanksCount] = useState(0);

  const banks = getFieldValue("bankAccount");
  const banksLength = banks && banks.length;
  const renderAccount = item => {
    const autoSearchBankActive = getFieldValue("autoSearchBankActive" + item);
    return (
      <div key={"bankAccount" + item}>
        <>
          <Divider />
          {!disabled && (
            <div className="customer-card-form__auto-search-checkbox">
              <Form.Item>
                {getFieldDecorator("autoSearchBankActive" + item, {
                  valuePropName: "checked"
                })(
                  <Checkbox style={{ fontWeight: "normal" }}>
                    Автоматическое определение данных организации по
                    наименованию или ИНН
                  </Checkbox>
                )}
              </Form.Item>
            </div>
          )}
          {autoSearchBankActive && (
            <div className="customer-card-form__unit">
              <span className="customer-card-form__label">Банк:</span>
              <div className="customer-card-form__item">
                <DadataSearchBank
                  style={{ width: 368 }}
                  form={form}
                  handleChange={e => handleChange(e, item)}
                />
              </div>
            </div>
          )}
          <div key={"bankName" + item} className="customer-card-form__unit">
            <span className="customer-card-form__label">
              Наименование банка:
            </span>
            <div className="customer-card-form__item">
              <Form.Item>
                {getFieldDecorator("bankName" + item, {
                  rules: [
                    {
                      required: true,
                      message: "Поле, обязательное для заполнения"
                    }
                  ]
                })(
                  <Input
                    style={{ width: 368 }}
                    placeholder="Укажите наименование банка"
                    disabled={autoSearchBankActive || disabled}
                  />
                )}
              </Form.Item>
            </div>
          </div>
          <div
            key={"bankAccountId" + item}
            className="customer-card-form__unit"
            hidden
          >
            <div className="customer-card-form__item">
              <Form.Item>
                {getFieldDecorator("bankAccountId" + item)(<Input hidden />)}
              </Form.Item>
            </div>
          </div>
          <div key={"bik" + item} className="customer-card-form__unit">
            <span className="customer-card-form__label">БИК:</span>
            <div className="customer-card-form__item">
              <Form.Item>
                {getFieldDecorator("bik" + item, {
                  rules: [
                    {
                      required: true,
                      message: "Поле, обязательное для заполнения"
                    },
                    {
                      validator: (rule, value, callback) => {
                        if (!isNumeric(value) && value) {
                          callback("Недопустимый символ");
                        } else if (value && Array.from(value).length < 9) {
                          callback("БИК должен быть длиной в 9 цифр");
                        } else {
                          callback();
                        }
                      }
                    }
                  ]
                })(
                  <Input
                    style={{ width: 224 }}
                    placeholder="Укажите БИК"
                    maxLength={9}
                    disabled={autoSearchBankActive || disabled}
                  />
                )}
              </Form.Item>
            </div>
          </div>
          <div key={"accountCorr" + item} className="customer-card-form__unit">
            <span className="customer-card-form__label">
              Корреспондентский счет:
            </span>
            <div className="customer-card-form__item">
              <Form.Item>
                {getFieldDecorator("accountCorr" + item, {
                  rules: [
                    {
                      required: true,
                      message: "Поле, обязательное для заполнения"
                    },
                    {
                      validator: (rule, value, callback) => {
                        if (!isNumeric(value) && value) {
                          callback("Недопустимый символ");
                        } else {
                          callback();
                        }
                      }
                    }
                  ]
                })(
                  <Input
                    placeholder="Укажите корр. счет"
                    style={{ width: 224 }}
                    maxLength={22}
                    disabled={autoSearchBankActive || disabled}
                  />
                )}
              </Form.Item>
            </div>
          </div>
          <div
            key={"bankAccountNum" + item}
            className="customer-card-form__unit"
          >
            <span className="customer-card-form__label">Расчетный счет:</span>
            <div className="customer-card-form__item">
              <Form.Item>
                {getFieldDecorator("bankAccountNum" + item, {
                  rules: [
                    {
                      required: true,
                      message: "Поле, обязательное для заполнения"
                    },
                    {
                      validator: (rule, value, callback) => {
                        if (!isNumeric(value) && value) {
                          callback("Недопустимый символ");
                        } else {
                          callback();
                        }
                      }
                    }
                  ]
                })(
                  <Input
                    placeholder="Укажите расчетный счет"
                    style={{ width: 224 }}
                    maxLength={20}
                    disabled={disabled}
                  />
                )}
              </Form.Item>
            </div>
          </div>
        </>
        {!disabled && (
          <div className="customer-card-form__remove-bank">
            <div
              className="add-more-link"
              onClick={() => deleteBank(item)}
              style={{
                color: "#00a8ff",
                cursor: "pointer",
                display: "inline-block"
              }}
            >
              <Icon type="minus-circle" />
              Удалить банковские реквизиты по этому банку
            </div>
          </div>
        )}
      </div>
    );
  };

  const addNewBank = () => {
    const keys = getFieldValue("bankAccount");
    let nextKeys;
    if (!keys || keys.length === 0) {
      nextKeys = [0];
      setBanksCount(0);
    } else {
      nextKeys = keys.concat(banksCount + 1);
      setBanksCount(banksCount + 1);
    }
    setFieldsValue({ bankAccount: nextKeys });
  };

  const deleteBank = index => {
    const keys = getFieldValue("bankAccount");
    // Защита от дурака
    if (!keys) return;
    let obj = {};
    // Очищаем поля если таковые были заполнены
    if (getFieldValue(`bankName${index}`)) {
      obj[`bankName${index}`] = null;
    }
    if (getFieldValue(`bankAccountNum${index}`)) {
      obj[`bankAccountNum${index}`] = null;
    }
    if (getFieldValue(`autoSearchBankActive${index}`)) {
      obj[`autoSearchBankActive${index}`] = null;
    }
    if (getFieldValue(`bik${index}`)) {
      obj[`bik${index}`] = null;
    }
    if (getFieldValue(`accountCorr${index}`)) {
      obj[`accountCorr${index}`] = null;
    }

    if (getFieldValue(`bankAccountId${index}`)) {
      obj[`bankAccountId${index}`] = null;
    }

    setFieldsValue({
      bankAccount: keys.filter(key => key !== index),
      ...obj
    });
  };

  const updateBanks = (val, index) => {
    if (banks) {
      let obj = {};
      obj["bankName" + index] = val.data.name.payment;
      obj["bik" + index] = val.data.bic;
      obj["accountCorr" + index] = val.data.correspondentAccount;
      setFieldsValue({ ...obj });
    }
  };
  return (
    <>
      <Form.Item className="hidden-block">
        {getFieldDecorator("bankAccount")(<Input type="hidden" />)}
      </Form.Item>
      {banksLength > 0 &&
        banks.map(item => {
          return renderAccount(item);
        })}
      {!disabled && (
        <div className="customer-card-form__add-bank">
          <div
            className="add-more-link"
            onClick={addNewBank}
            style={{
              color: "#00a8ff",
              cursor: "pointer",
              display: "inline-block"
            }}
          >
            <Icon type="plus-circle" />
            Добавить реквизиты банка
          </div>
        </div>
      )}
    </>
  );
};
